import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
// import { GoogleMapsModule } from "@angular/google-maps";
// import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { SharedModule } from '../../shared.module';

import { CkeditorBlockComponent, TextBlockComponent, LinkDescriptionBlockComponent, PictureBlockComponent, DisqusBlockComponent, SocialFeedBlockComponent, CalendarBlockComponent, PatientsBlockComponent, InquiryBlockComponent, SurveyBlockComponent, QuestionnaireBlockComponent, QuestionnaireSubOptionComponent, DescriptionSubOptionComponent, StartWrapperBlockComponent, AddSpaceComponent, FormTitleBlockComponent, QuestionsBlockComponent, ConfirmationBlockComponent, PasswordBlockComponent, NextBlockComponent, FormPhotoComponent, FormDocumentComponent, PainLevelComponent, DrawToolBlockComponent, PhysicianBlockComponent, EndWrapperBlockComponent, FillBlockComponent, NotesBlockComponent, ButtonsBlockComponent, ContactUsBlockComponent, PlacefullBlockComponent, AddToCartBlockComponent, CartBlockComponent, BlanksFormBlockComponent, ExclusiveUrlBlockComponent, FileUploadBlockComponent, PushpayBlockComponent, ThreedCartBlockComponent, BlogsBlockComponent, ChatBlockComponent, AccountBlockComponent, ProfileBlockComponent, TileSelectDialogComponent, TileDataComponent, TilesListComponent, CustomTileViewComponent, WidgetComponent, ModalPreviewDialogComponent, CustomSelectCreateAutocompleteComponent, FormLoadingScreenComponent, ScoreTileDataComponent, DataListComponent, DataAssignDialogComponent, FormIframeUrlComponent, ModalTileDialogComponent, ModalQuestionFlagDialogComponent, VideoInputEntityDialogComponent, XEditorBlockComponent } from './components';

import {
    ActionNotificationComponent,
    DeleteEntityDialogComponent,
    FetchEntityDialogComponent,
    UpdateStatusDialogComponent,
    AlertEntityDialogComponent,
    AlertActionEntityDialogComponent,
    UpdateEntityDialogComponent,
    ErrorEntityDialogComponent,
    ConfirmSelectEntityDialogComponent,
    ConfirmCkeditorEntityDialogComponent,
    ConfirmInputEntityDialogComponent
} from './modals';

import { ImageCropperModule } from 'ngx-image-cropper';
import { MatTooltipModule } from '@angular/material/tooltip';
// import { DeviceDetectorModule } from 'ngx-device-detector';

import { FormUtils } from './helpers/utils';
import { FormLayoutUtilsService, FormLoaderService, FormRequestService } from './services';
import { RestrictInputDirective, ResizeableDirective } from './directives';
import { AngularEditorModule } from './lib/x-editor';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';
import { SafeHtmlPipe } from './pipes';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        // GoogleMapsModule,
        FormsModule,
        // SharedModule,
        ReactiveFormsModule,
        AngularEditorModule,
        ImageCropperModule,
        // FlexLayoutModule.withConfig({ addFlexToParent: false }),
        MatTooltipModule,
        MatInputModule,
        MatTabsModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatButtonModule,
        MatSelectModule,
        MatOptionModule,
        MatCheckboxModule,
        DragDropModule,
        MatIconModule,
        MatRadioModule,
        MatFormFieldModule,
        MatProgressBarModule,
        MatCardModule,
        MatListModule,
        MatDividerModule,
        MatAutocompleteModule,
        MatMenuModule,
        // DeviceDetectorModule
    ],
    providers: [
        // GlobalService
        FormUtils,
        FormLayoutUtilsService,
        FormLoaderService,
        FormRequestService
    ],
    declarations: [
        SafeHtmlPipe,
        ConfirmCkeditorEntityDialogComponent,
        WidgetComponent,
        PictureBlockComponent,
        DisqusBlockComponent,
        SocialFeedBlockComponent,
        CalendarBlockComponent,
        PatientsBlockComponent,
        InquiryBlockComponent,
        SurveyBlockComponent,
        QuestionnaireBlockComponent,
        QuestionnaireSubOptionComponent,
        DescriptionSubOptionComponent,
        StartWrapperBlockComponent,
        AddSpaceComponent,
        FormTitleBlockComponent,
        QuestionsBlockComponent,
        ConfirmationBlockComponent,
        PasswordBlockComponent,
        NextBlockComponent,
        FormPhotoComponent,
        FormDocumentComponent,
        PainLevelComponent,
        DrawToolBlockComponent,
        PhysicianBlockComponent,
        EndWrapperBlockComponent,
        FillBlockComponent,
        NotesBlockComponent,
        ButtonsBlockComponent,
        ContactUsBlockComponent,
        PlacefullBlockComponent,
        AddToCartBlockComponent,
        CartBlockComponent,
        BlanksFormBlockComponent,
        ExclusiveUrlBlockComponent,
        FileUploadBlockComponent,
        PushpayBlockComponent,
        ThreedCartBlockComponent,
        BlogsBlockComponent,
        ChatBlockComponent,
        AccountBlockComponent,
        ProfileBlockComponent,
        TextBlockComponent,
        LinkDescriptionBlockComponent,
        CkeditorBlockComponent,
        ModalPreviewDialogComponent,
        TileSelectDialogComponent,
        TileDataComponent,
        TilesListComponent,
        CustomTileViewComponent,
        CustomSelectCreateAutocompleteComponent,
        ConfirmInputEntityDialogComponent,
        ActionNotificationComponent,
        DeleteEntityDialogComponent,
        FetchEntityDialogComponent,
        UpdateStatusDialogComponent,
        AlertEntityDialogComponent,
        AlertActionEntityDialogComponent,
        UpdateEntityDialogComponent,
        ErrorEntityDialogComponent,
        ConfirmSelectEntityDialogComponent,
        FormLoadingScreenComponent,
        DataListComponent,
        ScoreTileDataComponent,
        DataAssignDialogComponent,
        FormIframeUrlComponent,
        ModalTileDialogComponent,
        ModalQuestionFlagDialogComponent,
        RestrictInputDirective,
        VideoInputEntityDialogComponent,
        XEditorBlockComponent,
        ResizeableDirective
    ],
    exports: [DataAssignDialogComponent, DataListComponent, DataListComponent, TilesListComponent, TileDataComponent, ScoreTileDataComponent, XEditorBlockComponent, CustomSelectCreateAutocompleteComponent, FormIframeUrlComponent]
})
export class FormLibrariesComponentModule { }
